<template>
  <div class="flex items-center h-full">
    <vs-button
      color="primary"
      type="filled"
      icon-pack="feather"
      icon="icon-edit"
      @click="editData"
    ></vs-button>    
  </div>
</template>

<script>
export default {
  name: 'EditActions',
  methods: {
    editData () {
      // 
      this.$router.push({
        name: 'user-profile',
        params: { teacher_id: this.params.data.basic_details.operation_user_id, editable: true }
      })
    }
  }
}
</script>